<ion-header [translucent]="true">
  <ion-toolbar class="toolbar-with-closing-button !px-2 md:!px-4">
    <div slot="start" class="hidden md:flex">
      <dojo-icon-button (click)="closeDialog()" [icon]="'times'"></dojo-icon-button>
    </div>
    <div slot="end" class="hidden md:flex md:w-8"></div>
    <ion-title class="common-ion-title">{{ 'Crop image' }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="flex h-full grow flex-col p-4">
    <div class="relative mb-4 flex grow">
      <image-cropper
        [imageFile]="file"
        [maintainAspectRatio]="options.lockRatio ?? false"
        [containWithinAspectRatio]="containWithinAspectRatio"
        [aspectRatio]="ratio"
        [onlyScaleDown]="true"
        [roundCropper]="false"
        [canvasRotation]="canvasRotation"
        [transform]="transform"
        [alignImage]="'left'"
        [style.display]="showCropper ? null : 'none'"
        output="base64"
        format="png"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        class="image-cropper"
      ></image-cropper>
    </div>
    <div class="image-crop-dialog-footer">
      <ng-container *ngIf="options.enableRotate">
        <button mat-flat-button (click)="rotateLeft()">
          <dojo-icon [icon]="'undo'"></dojo-icon>
          <span>Rotate left</span>
        </button>

        <button mat-flat-button (click)="rotateRight()">
          <dojo-icon [icon]="'redo'"></dojo-icon>
          <span>Rotate right</span>
        </button>
      </ng-container>

      <ng-container *ngIf="options.enableFlip">
        <button mat-flat-button (click)="flipVertical()">
          <dojo-icon [icon]="'arrows-alt-v'"></dojo-icon>
          <span>Flip vertical</span>
        </button>

        <button mat-flat-button (click)="flipHorizontal()">
          <dojo-icon [icon]="'arrows-alt-h'"></dojo-icon>
          <span>Flip horizontal</span>
        </button>
      </ng-container>

      <button mat-flat-button *ngIf="options.enableContain" (click)="toggleContainWithinAspectRatio()">
        <dojo-icon [icon]="containWithinAspectRatio ? 'expand-arrows-alt' : 'expand-wide'"></dojo-icon>
        <span>Toggle contain</span>
      </button>

      <ng-container *ngIf="options.enableZoom">
        <button mat-flat-button (click)="zoomOut()">
          <dojo-icon [icon]="'search-minus'"></dojo-icon>
          <span>Zoom out</span>
        </button>

        <button mat-flat-button (click)="zoomIn()">
          <dojo-icon [icon]="'search-plus'"></dojo-icon>
          <span>Zoom in</span>
        </button>
      </ng-container>
    </div>
  </div>

  <div class="image-crop-dialog-panel">
    @if (options.showDimensions) {
      <p class="size-properties-block">
        Dimensions
        <span class="rounded-standard bg-white p-2"> h: {{ imgHeight }} </span>
        <dojo-icon [icon]="'close'"></dojo-icon>
        <span class="rounded-standard bg-white p-2"> w: {{ imgWidth }} </span>
      </p>
    }

    <div *ngIf="options.enableRatio && ratioOptions.length">
      <h4 class="image-crop-dialog-subtitle">Aspect ratio</h4>
      <div class="flex items-start gap-2">
        <div class="custom-mat-form-wrapper grow">
          <mat-form-field appearance="fill" class="w-full">
            <mat-select
              [(ngModel)]="ratio"
              (selectionChange)="changeRatio($event)"
              hideSingleSelectionIndicator
              panelClass="custom-mat-select-panel"
            >
              <mat-option *ngFor="let ratio of ratioOptions; trackBy: trackByValueProp" [value]="ratio.value">
                {{ ratio.key }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <button
          *ngIf="options.enableRatio"
          mat-flat-button
          color="primary"
          (click)="toggleLock()"
          class="image-crop-lock-button"
        >
          {{ lockRatio ? 'Unlock' : 'Lock' }}
        </button>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="shadow-subtle bg-neutral-0 border-t border-solid border-neutral-200">
  <div class="small:flex-row flex flex-col justify-end gap-2 p-4">
    <dojo-button (click)="crop()" class="small:w-auto small:order-2 block w-full">Crop</dojo-button>
    <dojo-button (click)="closeDialog()" class="small:w-auto small:order-1 block w-full" [fill]="'outline'"
      >Cancel
    </dojo-button>
  </div>
</ion-footer>
